<template>
    <v-container class="unauthenticated fill-height" fluid>
            <v-row class="unauthenticated_logincard" align="center" justify="center">
                <v-col cols="12" md="8">
                    <v-card elevation="3" class="mx-auto align-center justify-center" max-width="700">
                        <v-card elevation="0" color="#004236" height="200" style="text-align:center;">
                            <br />
                            <img src="../../assets/background/KingsLogoinWhite.png" height="150" width="230" style="margin:auto;"/>
                            <br />
                        </v-card><br />
                        <v-row align-content="center" justify="center">
                            <v-col cols="12"></v-col>
                            <v-col cols="12" class="d-flex justify-center ma-0 pa-0"><span class="text-h5 text-center" style="width: 100%;">CUPE Application Portal</span></v-col>
                            <v-col cols="8" class="ma-0 pa-0">
                                <v-progress-linear
                                    color="#d7ae28"
                                    rounded
                                    value="100"
                                ></v-progress-linear>
                            </v-col>
                            <v-col cols="12">
                                <v-card-text class="text--primary">
                                    <v-alert border="left" :color="warningColor" prominent type="warning">
                                        This resource is restricted and requires authorized access. <br />
                                        If you are reaching the <b>applicant sign in page</b>, please ensure that you are currently <b>not</b> signed into MyKing's in the same browser. <br />
                                        If you are reaching the admin side, your account may be inactive or experiencing technical issues. <br />
                                        Please contact to King's HR at <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> if you have any questions.
                                    </v-alert>
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'unauthorized',
    data() {
        return {
            
        }
    },
    methods: {
    }
}
</script>

<style scoped>
.headline {
    word-break: normal;
}
.unauthenticated{
    background-image: url('../../assets/background/unauthenticated_bg.png');

    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>